import React from "react";

function BS4_GridSystem() {
  return (
    <div>
      <h1>BS4_GridSystem Component</h1>
      <p>This is the BS4_GridSystem tutorial page content.</p>
    </div>
  );
}

export default BS4_GridSystem;
